import React from "react";
import CharacteristicCard from "./CharacteristicCard/CharacteristicCard";
import { CHARACTERISTICS } from "./constants";
import ReactMarkdown from "react-markdown";
import { CharacteristicsWrapper, DescriptionText } from "./styles";
import AdvertiseNowBanner from "../../AdvertiseNowBanner/AdvertiseNowBanner";
import HowToRentCard from "../../HowToRentCard";
import GuaranteesSection from "../../GuaranteesSection";
import { PropertyGuarantee } from "../../../../../global/types";
import { getFurnishedBadgeTitle } from "../../../../../utils/furnishedStatus";

export type Property = {
  id: number;
  consultant_id: number;
  address_id: number;
  address: PropertyAddress;
  title: string;
  description: string;
  allow_pets: number;
  water_included: number;
  gas_included: number;
  area: number;
  rooms: number;
  bathrooms: number;
  suites: number;
  garages: number;
  garbage_tax: string;
  is_furnished: number;
  rent_value: string;
  condominium_value: string;
  condominium_free: number;
  iptu_value: string;
  is_nearby_clinics: number;
  is_nearby_major_roads: number;
  is_nearby_schools: number;
  is_nearby_mall: number;
  is_nearby_public_transport: number;
  is_rented: number;
  has_ac: number;
  has_backyard: number;
  has_porch: number;
  has_storage: number;
  has_cable_tv: number;
  has_bbq: number;
  has_elevator: number;
  has_garden: number;
  has_gourmet: number;
  has_gym: number;
  has_party: number;
  has_playground: number;
  has_pool: number;
  has_home_cinema: number;
  has_tennis_court: number;
  has_sports: number;
  has_sauna: number;
  has_spa: number;
  has_sea_view: number;
  has_gourmet_porch: number;
  has_24h_concierge: number;
  has_game_room: number;
  guarantees?: PropertyGuarantee[];
};

type PropertyAddress = {
  address: string;
  neighborhood: string;
  city: string;
  uf: string;
  number: number;
  complement: string;
  latitude: string;
  longitude: string;
};

interface Props {
  property: Property;
}

function CharacteristicsTab({ property }: Props) {
  const HAS_CHARACTERISTIC = [
    property.allow_pets,
    property.water_included,
    property.gas_included,
    // Furnished is 0, 1 or 2. The badge title is resolved separately.
    0,
    property.has_ac,
    property.has_backyard,
    property.has_porch,
    property.has_storage,
    property.has_cable_tv,
    property.has_bbq,
    property.has_elevator,
    property.has_garden,
    property.has_gourmet,
    property.has_gym,
    property.has_party,
    property.has_playground,
    property.has_pool,
    property.has_home_cinema,
    property.has_tennis_court,
    property.has_sports,
    property.has_sauna,
    property.has_spa,
    property.has_sea_view,
    property.has_gourmet_porch,
    property.has_24h_concierge,
    property.has_game_room,
  ];

  return (
    <>
      <DescriptionText>  
        <ReactMarkdown>{property.description || ""}</ReactMarkdown>
      </DescriptionText>
      <CharacteristicsWrapper>
        {CHARACTERISTICS.map((characteristic, index) => {
          if (characteristic.title === "Mobiliado") {
            const furnishedTitle = getFurnishedBadgeTitle(property.is_furnished);

            if (!furnishedTitle) {
              return null;
            }

            return (
              <CharacteristicCard
                key={furnishedTitle}
                Icon={characteristic.Icon}
                title={furnishedTitle}
              />
            );
          }

          return HAS_CHARACTERISTIC[index] ? (
            <CharacteristicCard
              key={characteristic.title}
              {...characteristic}
            />
          ) : null;
        })}
      </CharacteristicsWrapper>
      <HowToRentCard />
      <GuaranteesSection guarantees={property.guarantees} />
      <AdvertiseNowBanner propertyId={property.id} />
    </>
  );
}

export default CharacteristicsTab;
